import { Flex, Text } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/react'
import { Voicemail } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { QuickActionButton } from '~/components/shared/QuickActionButton'
import { Tooltip } from '~/components/ui/tooltip'
import {
  CallOutcomeCellVariant,
  useCallOutcomeCellStyles,
} from '~/pages/Calls/componentStyles/CallsListItem.style'
import { Size } from '~/types/ThemeTypes'

import { CallDirection } from '@mangovoice/types'

interface CallOutcomeCellProps {
  text: string
  icon: React.ComponentType<any>
  columnStyles: Record<string, any>
  direction: CallDirection
  hasVoicemail?: boolean
  size?: Size
  variant: CallOutcomeCellVariant
  onVoicemailClick?: () => void
}
export const CallOutcomeCell = ({
  columnStyles,
  text,
  icon,
  direction,
  hasVoicemail,
  size,
  variant = CallOutcomeCellVariant.Success,
  onVoicemailClick,
}: CallOutcomeCellProps) => {
  const { t } = useTranslation()
  const styles = useCallOutcomeCellStyles({ variant })

  const shouldCollapse = size === Size.sm || size === Size.md

  const tooltipText = `${t(`callDetailData.direction.${direction}`)}\n${text}`

  return (
    <Flex role="cell" css={{ ...columnStyles, ...styles.container }}>
      <Tooltip
        showArrow
        positioning={{ placement: 'top' }}
        content={tooltipText}
        disabled={!shouldCollapse}
      >
        <Flex css={styles.iconWrapper}>
          <Icon css={styles.icon}>
            {React.createElement(icon, { size: '100%' })}
          </Icon>
        </Flex>
      </Tooltip>
      {!shouldCollapse && <Text css={styles.text}>{text}</Text>}
      {hasVoicemail && (
        <QuickActionButton
          actionIcon={Voicemail}
          variant={QuickActionButtonVariants.Default_100}
          size={Size.sm}
          tooltipText={t('nav.voicemail')}
          onClick={onVoicemailClick}
        />
      )}
    </Flex>
  )
}
